module.exports = __webpack_public_path__ + "static/media/2015_conf_Design_Story_of_Smart_Food_Nutrition.25261ba0.png";